import React from "react"
import { Link } from "gatsby"
import ArrowLeft from "../images/arrow-left.svg"

import styles from "../styles/components/community-button.module.scss"

const CommunityButton = () => {
  return (
    <div className={styles.buttonContainer}>
      <div className={styles.dropShadow}>
        <Link to="/our-community" className={styles.backButton}>
          <ArrowLeft />
          <span>Back to Community</span>
        </Link>
      </div>
    </div>
  )
}

export default CommunityButton
